const headers = [
  {
    text: 'sale.sale_status',
    value: 'isEnabled',
    sortable: true,
    width: '8%',
    align: 'center'
  },
  {
    text: 'payment.payment_sale-payment-way',
    value: 'name',
    sortable: true,
    width: '82%'
  },
  {
    text: 'common.input_sort-number',
    value: 'sortNumber',
    sortable: true,
    width: '9%'
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '9%'
  }
]
export default { headers }
